import './AppDisplay.scss';

import classNames from 'classnames';
import { DataSecurityAppLogos } from './DataSecurityAppLogos';
import { DataSecurityAppName } from './DataSecurityAppNames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { Tag } from 'antd';
import { useApplicationReference } from '@hooks';

import { Else, If, Then, When } from 'react-if';
import { SwapLeftOutlined, SwapOutlined, SwapRightOutlined } from '@ant-design/icons';

function getDirectionIcon(read: boolean | undefined, write: boolean | undefined) {
	if (read === undefined && write === undefined) {
		return null;
	}

	if (read && write) {
		return <SwapOutlined />;
	}

	if (read) {
		return <SwapRightOutlined />;
	}

	if (write) {
		return <SwapLeftOutlined />;
	}

	return null;
}

export interface AppDisplayProps {
	appId: number;
	appLabel?: string;
	appName?: string;
	className?: string;
	hideArrows?: boolean;
	hideLabel?: boolean;
	loading?: boolean;
	read?: boolean;
	write?: boolean;
}

export const AppDisplay: React.FC<AppDisplayProps> = ({
	appId,
	appLabel,
	appName,
	className,
	hideArrows,
	hideLabel,
	loading,
	read,
	write,
	...rest
}) => {
	const { label, name } = useApplicationReference(appId);
	const logo = DataSecurityAppLogos[ (appName || name) as DataSecurityAppName ] ?? '';

	const appDisplayClassNames = classNames('application-display', className);

	return (
		<div
			className={ appDisplayClassNames }
			{ ...rest }>
			<LoadingSpinner
				indicator={ <div /> }
				spinning={ loading }>
				<Tag className='application-name'>
					<When condition={ !hideArrows }>
						{ getDirectionIcon(read, write) }
					</When>
					<If condition={ logo }>
						<Then>
							<img
								className='application-logo'
								src={ logo } />
						</Then>
						<Else>
							<div className='application-name-text'>{ appName || name }</div>
						</Else>
					</If>
				</Tag>
				<When condition={ (appLabel || label) && !hideLabel }>
					<Tag className='application-label'>{ appLabel || label }</Tag>
				</When>
			</LoadingSpinner>
		</div>
	);
};
